import * as Communication from '@translations/en/Communication.json';
import * as common from '@translations/en/common.json';
import * as integrations from '@translations/en/integrations.json';
import * as safetycheck from '@translations/en/safetycheck.json';
import * as signup from '@translations/en/signup.json';
import i18n from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { FALLBACK_LANGUAGE, type Language } from './locales';
import { getInitialLanguage } from './resolveSupportedLanguage';

import.meta.glob('@translations/**/*.json');

export {
  getInitialLanguage,
  resolveSupportedLanguage,
} from './resolveSupportedLanguage';

export const resources = {
  en: {
    common,
    Communication,
    integrations,
    safetycheck,
    signup,
  },
};
export const defaultNS = ['common'];

const availableNameSpaces = [
  'common',
  'Communication',
  'integrations',
  'safetycheck',
  'signup',
] as const;

export type NameSpace = (typeof availableNameSpaces)[number];

i18n
  .use(
    resourcesToBackend(
      (language: Language, namespace: NameSpace) =>
        import(`@translations/${language}/${namespace}.json`),
    ),
  )
  .init({
    lng: getInitialLanguage(),
    fallbackLng: {
      default: [FALLBACK_LANGUAGE],
    },
    defaultNS,
    fallbackNS: 'common',
    returnEmptyString: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
